import type React from 'react'
import { useState } from 'react'
import styled from 'styled-components'

import EditButton from '@/components/EditButton'
import EditRefereePanel from '@/components/EntityPanels/Referee'
import ExpandeableCard from '@/components/ExpandableCard'
import TooltipIcon from '@/components/IconGroup/TooltipIcon'
import type { Application } from '@/types/Activity'

import LandlordReferenceBody from './LandlordReferenceBody'

interface Props {
  application: Application
}

const Container = styled.div``

const LandlordReferencePanel: React.FC<Props> = ({ application }) => {
  const [editPanelOpen, seIsEditPanelOpen] = useState(false)

  const attachedSubjects = application.attachedSubjects ?? []

  const completedMilestone = application.milestones.find(
    milestone => milestone.event === 'subject.complete',
  )

  const isEditDisabled = attachedSubjects.length > 1 || completedMilestone !== undefined

  return (
    <>
      {editPanelOpen && (
        <EditRefereePanel
          subjectData={{
            customerId: application.customerId,
            subjectId: application.subjectId,
            name: application?.context?.name ?? '',
            email: application?.context?.email ?? '',
            phone: application?.context?.mobile ?? '',
          }}
          refereeType="landlord"
          setOpen={() => seIsEditPanelOpen(false)}
        />
      )}
      <Container>
        <ExpandeableCard
          label="Landlord Reference"
          icon="landlord"
          actionButton={
            <>
              {isEditDisabled ? (
                <TooltipIcon
                  tooltipMessage={`${
                    attachedSubjects.length > 1
                      ? 'Cannot edit referee details as the referee has multiple attached applicants'
                      : 'Cannot edit referee details as the referee has completed the journey'
                  }`}
                  icon={
                    <EditButton
                      isDisabled={isEditDisabled}
                      onClick={() => seIsEditPanelOpen(true)}
                    />
                  }
                />
              ) : (
                <EditButton onClick={() => seIsEditPanelOpen(true)} />
              )}
            </>
          }
          expandedContent={<LandlordReferenceBody application={application} />}
          isExpanded={true}
        />
      </Container>
    </>
  )
}

export default LandlordReferencePanel
